import { h, defineComponent, VNodeChildren } from 'vue';
import Star from '@/_legacy/components/Icons/Star.vue';

export interface StarredItemProps {
  isStarred: boolean;
}

// old style with one star
export const StarredItem = defineComponent<StarredItemProps>({
  name: 'StarredItem',
  props: ['isStarred'],
  setup(props, context) {
    return function render() {
      return h('span', {
        class: 'starred',
      }, [
        h('span', context.slots.default?.()),
        props.isStarred ? h(Star) : null,
      ]);
    };
  },
});

export function starredItem(content: VNodeChildren, isStarred = false) {
  return h(
    StarredItem,
    {
      props: { isStarred },
    },
    content,
  );
}

export const starredItemCurried = (isStarred: boolean) => (content: VNodeChildren) => starredItem(content, isStarred);
